import Error from "@mui/icons-material/Error";
import Lock from "@mui/icons-material/Lock";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CallFeature, Interval } from "../../api/graphql";
import { isConfidentialCall } from "../../lib/securityFeaturesUtils.ts";
import { formatTimer } from "../../lib/timeFormats";

type Props = {
  contact: { fullName: string };
  interval?: Pick<Interval, "startAt" | "endAt">;
  features: CallFeature[];
};

export default function VoiceCallContext({
  contact,
  interval,
  features,
}: Props) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        width: 1,
        position: "absolute",
        zIndex: "modal",
        color: "white",
        left: 0,
        top: 0,
        p: 2,
        flexDirection: "column",
      }}
    >
      <Typography variant="h3">{contact.fullName}</Typography>
      {interval && (
        <Typography
          variant="body1"
          sx={{
            color: "dark.text.secondary",
          }}
        >
          {t("Time limit:")} {formatTimer(interval.endAt - interval.startAt)}
        </Typography>
      )}
      {!isConfidentialCall(features) ? (
        <Typography
          variant="body1"
          sx={{
            color: "dark.text.secondary",
          }}
        >
          {t("May be monitored or recorded")}{" "}
          <Error fontSize="small" sx={{ verticalAlign: "text-bottom" }} />
        </Typography>
      ) : (
        <Typography
          variant="body1"
          sx={{
            color: "dark.text.secondary",
          }}
        >
          {t("Not monitored or recorded")}
          <Lock fontSize="small" sx={{ verticalAlign: "text-bottom" }} />
        </Typography>
      )}
    </Box>
  );
}
